import { BuildInAppToolId, IAppToolConfig } from '../types/appTools';
import { useEvent } from '@bizzabo/entities';
import {
    IntegrationPointData,
    IntegrationPointType,
    Category,
} from '../../extensions/types/appExtension';
import useEventAppExtensions from '../../hooks/useEventAppExtensions';

const useEventExtensionAppTools = eventUniqueName => {
    const event = useEvent(eventUniqueName);
    const appExtension = useEventAppExtensions(
        event.data?.id,
        IntegrationPointType.VENUE_EVENT_SIDE_PANEL
    );

    let appTools: IAppToolConfig[] = [];
    if (appExtension) {
        const appExtensionData =
            appExtension.category === Category.GAMIFICATION
                ? IntegrationPointData.VENUE_EVENT_SIDE_PANEL_GAMIFICATION
                : IntegrationPointData.VENUE_EVENT_SIDE_PANEL;
        appTools = [
            {
                id: BuildInAppToolId.EventExtension,
                extensionId: appExtension.id,
                type: appExtension.type,
                title: appExtensionData.label,
                iconUrl: appExtensionData.icon,
                isVisible: () => true,
                category: appExtension.category,
                name: appExtension.name,
            },
        ];
    }

    return appTools;
};

export default useEventExtensionAppTools;
